import { dispatch, pathSubscription, subscription } from 'nike-re-framejs';
import luckyWheelClient from './utils/client';
import { LuckyWheelOfferType } from './utils/enums';
import Immutable, { fromJS, Map } from 'immutable';
import { LOCAL_STORAGE_FIRST_CASINO_VISIT, LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL } from './utils/utils';
import i18n from '../../common/i18n';

const sameLuckyWheelNotificationAlreadyShown = offerId =>
    Number(localStorage.getItem(LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL)) === offerId;

//subscriptions
export const luckyWheelSubscription$ = pathSubscription(['bonus', 'luckyWheel'], Map());

export const luckyWheelWin$ = pathSubscription(['bonus', 'luckyWheel', 'win'], null);
export const luckyWheelSpin$ = pathSubscription(['bonus', 'luckyWheel', 'spin'], null);

export const showLuckyWheelNotification$ = subscription(lw => {
    const offerId = lw.getIn(['offer', 'idLw']) || lw.getIn(['spin', 'idLw']);
    return !!(offerId && !sameLuckyWheelNotificationAlreadyShown(offerId));
}, luckyWheelSubscription$);

export const showLuckyWheelBanner$ = subscription(lw => {
    const offerId = lw.getIn(['offer', 'idLw']) || lw.getIn(['spin', 'idLw']);
    return lw.getIn(['showBanner'], false) || sameLuckyWheelNotificationAlreadyShown(offerId);
}, luckyWheelSubscription$);

export const showLuckyWheelError = pathSubscription(['bonus', 'luckyWheelError'], null);

// handlers

export const closeLuckyWheelNotification = db => {
    setLuckyWheelIdIntoLocalStorage(db);
    return db.setIn(['bonus', 'luckyWheel', 'showBanner'], true);
};

export const setLuckyWheelIdIntoLocalStorage = db => {
    const lw = db.getIn(['bonus', 'luckyWheel']);
    const offerId = lw.getIn(['offer', 'idLw']) || lw.getIn(['spin', 'idLw']);
    localStorage.setItem(LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL, JSON.stringify(offerId));
};

export const initLuckyWheel = db => {
    const loggedIn = db.get('loggedIn');
    if (loggedIn) {
        const lastIdModal = localStorage.getItem(LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL);
        let timeout = !lastIdModal ? 5500 : 0;
        setTimeout(() => dispatch(getLuckyWheelOffer), timeout);
        setInterval(() => {
            dispatch(getLuckyWheelOffer);
        }, 1000 * 60 * 5);
    } else {
        localStorage.removeItem(LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL);
        localStorage.removeItem(LOCAL_STORAGE_FIRST_CASINO_VISIT);
    }
    return db;
};

const getLuckyWheelOffer = db => {
    const luckyWheelSpinIdExists = db.getIn(['bonus', 'luckyWheel', 'spin', 'idLw']);
    if (luckyWheelSpinIdExists) {
        return db;
    }
    luckyWheelClient.get('/offer').then(res => {
        const { offerType, spin, offer } = res;
        handleResponse(offerType, spin, offer);
    });
};

export const setLuckyWheelAction = (action, successHandler) => db => {
    const idLw = db.getIn(['bonus', 'luckyWheel', 'offer', 'idLw']);
    luckyWheelClient
        .patch(`/accept/${idLw}/${action}`)
        .then(res => {
            successHandler();
            getLuckyWheelOffer(db);
        })
        .catch(error => {
            dispatch(handleError(error));
        });
};

export const spinLuckyWheel = db => {
    const idLw = db.getIn(['bonus', 'luckyWheel', 'spin', 'idLw']);
    luckyWheelClient
        .patch(`/spin/${idLw}`)
        .then(res => {
            dispatch(setSpinLuckyWheel(Immutable.fromJS(res)));
        })
        .catch(error => {
            dispatch(handleError(error));
        });
};

const setSpinLuckyWheel = response => db => {
    let newDb = db;
    newDb = newDb.setIn(['bonus', 'luckyWheel', 'win'], response);
    if (response.get('duplicateSpin')) {
        newDb = newDb.setIn(['bonus', 'luckyWheelError'], i18n('nui.lucky-wheel.duplicateSpin'));
    }
    return newDb;
};

const handleResponse = (offerType, spin, offer) => {
    switch (offerType) {
        case LuckyWheelOfferType.SPIN:
            dispatch(db =>
                db
                    .setIn(['bonus', 'luckyWheel', 'spin'], fromJS(spin))
                    .setIn(['bonus', 'luckyWheel', 'offerType'], offerType)
            );
            return;
        case LuckyWheelOfferType.OFFER:
            dispatch(db =>
                db
                    .setIn(['bonus', 'luckyWheel', 'offer'], fromJS(offer))
                    .setIn(['bonus', 'luckyWheel', 'offerType'], offerType)
                    .deleteIn(['bonus', 'luckyWheel', 'spin'])
            );
            return;
        default:
            dispatch(db => db.deleteIn(['bonus', 'luckyWheel']));
            return;
    }
};

const handleError = error => db => {
    const generalApiError = 'nui.lucky-wheel.general-api-error';
    let errorTranslated = i18n(generalApiError);

    if (error.response?.status === 412) {
        const code = error.response.data?.code;
        const key = 'nui.lucky-wheel.' + code;
        const translation = code && i18n(key);
        if (code && translation !== key) {
            errorTranslated = translation;
        }
    }
    return db.setIn(['bonus', 'luckyWheelError'], errorTranslated);
};

export const clearError = db => db.deleteIn(['bonus', 'luckyWheelError']);
